module.exports = __webpack_public_path__ + "img/mirage-hatchback-red-compressor.925bfa02.png";